
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class FileUpload extends Vue {
  $refs!: {
    fileInput: HTMLInputElement;
  };

  @Prop({
    default: "250px"
  })
  height!: string;

  @Prop()
  accept!: string;
  @Prop({
    default: false
  })
  saveInProgress!: boolean;

  @Prop({ default: true })
  acceptsMultiple!: boolean;

  get realStyle() {
    return {
      height: this.height,
      ...this.style
    };
  }

  style = {};

  handleDragEnter() {
    this.style = {
      background: "var(--gray100)"
    };
  }

  handleDragEnd() {
    this.style = {
      background: ""
    };
  }

  chooseFile() {
    this.$refs.fileInput.click();
  }

  handleFileInputFiles() {
    const files = this.$refs.fileInput.files as FileList;
    this.$emit("input", files);
    this.cleanInputFiles();
  }

  handleDroppedFiles(e: DragEvent) {
    this.style = {
      background: ""
    };

    if (e.dataTransfer) {
      this.$emit("input", e.dataTransfer.files);
      this.cleanInputFiles();
    }
  }

  cleanInputFiles() {
    // HTML5 won't let a user select the same file if it's already selected
    // So we reset the input to allow it (after using it), otherwise it feels like a bug.
    this.$refs.fileInput.value = "";
  }
}
